import { useState, useEffect, useRef } from "react";
import ApiClient from "../../methods/api/apiClient";
import loader from "../../methods/loader";
import methodModel from "../../methods/methods";
import { Link, useNavigate, useParams } from "react-router-dom";
import Layout from "../../components/global/layout";
import { Tooltip } from "antd";
import FormControl from "../../components/common/FormControl";
import PhoneInput from "react-phone-input-2";
import { toast } from "react-toastify";

const AddEditSubAdmin = () => {
  const { id } = useParams()
  const roleId = useRef()
  const [form, setform] = useState({
    firstName: "",
    lastName: "",
    email: "",
    dialCode: "",
    mobileNo: ""
  })
  const history = useNavigate()
  const [submitted, setSubmitted] = useState(false)
  const inValidEmail = methodModel.emailvalidation(form?.email)
  const formValidation = [
    { key: "email", required: true, message: "Email is required", email: true },
    { key: "firstName", required: true, message: "First name is required" },
    { key: "lastName", required: true, message: "Last name is required" },
  ]

  useEffect(() => {
    if (id) {
      subAdminDetails()
    } else {
      getSubAdminRoleId()
    }
  }, [])

  const getSubAdminRoleId = () => {
    ApiClient.get(`role/listing`).then(res => {
      if (res.success) {
        roleId.current = res?.data?.find(itm => itm?.name == "sub admin")?.id
      }
    })
  }

  const subAdminDetails = () => {
    loader(true)
    ApiClient.get(`user/profile?id=${id}`).then((res) => {
      if (res.success == true || res?.code == 200) {
        setform({
          ...form,
          firstName: res?.data?.firstName,
          lastName: res?.data?.lastName,
          email: res?.data?.email,
          dialCode: res?.data?.dialCode,
          mobileNo: res?.data?.mobileNo
        })
      }
      loader(false)
    })
  }

  const handleChangePhone = (phone, country) => {
    const dialCode = country?.dialCode
    setform({ ...form, dialCode: dialCode, mobileNo: phone?.replace(dialCode, "") })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    setSubmitted(true)
    let invalid = methodModel.getFormError(formValidation, form)
    if (invalid || !form?.mobileNo) return
    let method = "post"
    let url = "user/add"
    let value = {
      ...form,
      id: id || "",
      role: roleId.current,
    }
    if (id) {
      method = "put"
      url = "user/profile"
      delete value.role
    } else {
      delete value.id
    }
    loader(true)
    ApiClient.allApi(url, value, method).then((res) => {
      if (res.success) {
        history(`/subadmin`)
        loader(false)
      } else {
        loader(false)
        toast?.error(res?.message)
      }
    })
  }

  return (
    <>
      <Layout>
        <form onSubmit={handleSubmit} autoComplete="chrome-off">
          <div className="pprofile1">
            <div className="flex items-center mb-8">
              <Tooltip placement="top" title="Back">
                <Link to={`/subadmin`} className="!px-4 py-2 flex items-center justify-center rounded-lg shadow-btn hover:bg-[#F3F2F5] border transition-all mr-3">
                  <i className="fa fa-angle-left text-lg"></i>
                </Link>
              </Tooltip>
              <div>
                <h3 className="text-lg lg:text-2xl font-semibold text-[#111827]">{id ? "Edit" : "Add"} Sub Admin</h3>
              </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              <div className="mb-3">
                <FormControl
                  placeholder="First Name"
                  type="text"
                  name="firstName"
                  label="First Name"
                  value={form?.firstName}
                  onChange={(e) => setform({ ...form, firstName: e })}
                  required
                />
                {submitted && !form?.firstName && (<div className="invalid-feedback d-block">First name is required</div>)}
              </div>

              <div className="mb-3">
                <FormControl
                  placeholder="Last Name"
                  type="text"
                  name="lastName"
                  label="Last Name"
                  value={form?.lastName}
                  onChange={(e) => setform({ ...form, lastName: e })}
                  required
                />
                {submitted && !form?.lastName && (<div className="invalid-feedback d-block">Last name is required</div>)}
              </div>

              <div className="mb-3">
                <FormControl
                  placeholder="Email"
                  type="text"
                  name="email"
                  label="Email"
                  value={form?.email}
                  onChange={(e) => setform({ ...form, email: e })}
                  disabled={id ? true : false}
                  required
                />
                {submitted && !form?.email
                  ?
                  (<div className="invalid-feedback d-block">Email is required</div>)
                  :
                  (form?.email && submitted && !inValidEmail && (<div className="invalid-feedback d-block">Please enter valid email</div>))
                }
              </div>

              <div className="mobile_number mb-3">
                <label>Mobile Number <span className="text-red-600"> *</span></label>
                <PhoneInput
                  placeholder="Mobile Number"
                  className="mobile-input"
                  value={form?.dialCode + form?.mobileNo}
                  enableSearch={true}
                  autocompleteSearch={false}
                  onChange={(phone, country) => handleChangePhone(phone, country)}
                  inputProps={{ required: true, autoComplete: "one-time-code" }}
                />
                {(submitted && !form?.mobileNo) ? (<div className="invalid-feedback d-block">Mobile number is required</div>) : ""}
              </div>
            </div>

            <div className="text-right">
              <button type="submit" className="text-white bg-[#F58D18] bg-[#F58D18] focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2">
                {id ? "Update" : "Save"}
              </button>
            </div>
          </div>
        </form>
      </Layout>
    </>
  );
};

export default AddEditSubAdmin;
